import PropTypes from 'prop-types';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import GateDecisionIcon from 'assets/protocol-gate-decision.svg?react';
import styles from './ProtocolStepIcon.module.css';

// Icon keys from `PROTOCOL_STEP_ICON_BY_TYPE`, plus the panel's own cards (Detected, unavailable).
const ICONS = Object.freeze({
    clipboard: AssignmentOutlinedIcon,
    idCard: BadgeOutlinedIcon,
    barrier: GateDecisionIcon,
    detected: AutoAwesomeOutlinedIcon,
    info: InfoOutlinedIcon,
});

// The 24 px round badge in front of every card title (Figma "Base Step Elements").
function ProtocolStepIcon({ icon }) {
    const Icon = ICONS[icon] ?? BadgeOutlinedIcon;
    return (
        <span className={styles['step-icon']} aria-hidden="true">
            <Icon />
        </span>
    );
}

ProtocolStepIcon.propTypes = {
    icon: PropTypes.oneOf(Object.keys(ICONS)).isRequired,
};

export default ProtocolStepIcon;
